/**
 * Get magnetic variation from tkofData.
 * TkofData is same as adList. Example: "EKCH;5.1;04L[37;3000;3000;45];04LA10;04R[37;3302;3302;45];04RB1;04RB2;04RB3;04RB4;04RSHP[37;3302;3302;45];04RSHPB1;04RSHPB2;04RSHPB3;04RSHPB4;12[119;2800;2365;45];12K2;12K3;12D;12SHP[119;2800;2365;45];12SHPK2;12SHPK3;12SHPD;22L[217;3302;3302;45];22LV1;22LV2;22R[217;3594;3000;45];22RA1;22RA2;22RA3;22RA4;22RA5;30[299;2365;2095;45];30G1;30TMP[299;2365;2095;45];30G1TMP"
 * In which, we return 5.1 (a number)
 * */
export const getMagneticVariationFromTkofData = (tkofData) => {
  //// Test with no magnetic variation (9999.9)
  //   tkofData =
  //   'ESSA;-7.5;01L[4;3301;3301;45];01LY2;01LY3;01R[4;2500;2500;45];01RW3;08[70;2500;2500;45];08X3;19L[184;2500;2500;45];19LW6;19R[184;3301;3301;45];19RY9;19RY8;26[250;2500;2500;45]';
  if (!tkofData) return null;

  const parts = tkofData.split(';');
  let magneticVariation = parts[1];

  // Check if its a number or nan
  if (!magneticVariation || isNaN(magneticVariation)) {
    return null;
  }

  // 9999.9 means that there is no magnetic variation
  if (magneticVariation === '9999.9') {
    return 0;
  }

  return Number(magneticVariation);
};
